import { settingConfiguration } from '../configurations';
import { RESERVATION_SERVER } from '../constans';
import { HttpClient } from '../utils';

export const GetReservationType = (callback) => {
    const url = settingConfiguration.get(RESERVATION_SERVER);
    HttpClient.get(`${url}/api/Reservation/GetReservationType?takeAll=false`, { cache: true }, (result) => {
        if (callback) callback(result.data, result);
    })
};